import React, { useCallback, useContext } from 'react';
import { useField } from 'react-final-form';
import { Label, FlexMiddle } from '@ubeya/shared-web/components';
import { getDaysOfWeek } from '@ubeya/shared/utils/time';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import DayButton from './DayButton';

const DaysFields = ({ title, name, className, onlyOne }) => {
  const { t } = useContext(ConfigContext);
  const {
    input: { value, onChange }
  } = useField(name);

  const handleToggle = useCallback(
    (index) => {
      if (onlyOne) {
        return onChange(index);
      }

      const selectedDayIndex = (value || []).findIndex((day) => day === index);
      if (selectedDayIndex > -1) {
        onChange([...(value || []).slice(0, selectedDayIndex), ...(value || []).slice(selectedDayIndex + 1)]);
      } else {
        onChange([...(value || []), index]);
      }
    },
    [onChange, onlyOne, value]
  );
  return (
    <Label title={title} className={className}>
      <FlexMiddle>
        {getDaysOfWeek().map(({ index, day }) => (
          <DayButton
            key={index}
            isSelected={onlyOne ? index === value : value.includes(index)}
            onClick={() => handleToggle(index)}>
            {t(day)}
          </DayButton>
        ))}
      </FlexMiddle>
    </Label>
  );
};

export default DaysFields;
